<template>
  <div id="app">
    <app-loading />
    <!-- / Splash screen -->
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="../../../node_modules/bootstrap-vue/dist/bootstrap-vue.css" lang="css"></style>
<style src="../../../node_modules/toastr/build/toastr.css" lang="css"></style>
<style src="../../../node_modules/vue-multi-select/dist/lib/vue-multi-select.css" lang="css"></style>
<style src="../../../node_modules/vue2-dropzone/dist/vue2Dropzone.min.css" lang="css"></style>
<style src="../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css" lang="css"></style>
<style src="../../../node_modules/pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css" lang="css"></style>
<style src="./style.scss" lang="scss"></style>

<script>
import AppLoading from './AppLoading'

export default {
  name: 'app',
  metaInfo: {
    title: 'MeritEHS',
    //titleTemplate: '% :: Gearbox'
  },

  components: {
    'app-loading': AppLoading,
  },

  methods: {

  },

  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1);
  },

  mounted(){
      //Get the alerts
      this.$root.getAlerts();

      //Space
      const self = this;

      //Get new alerts every 60 sections
      setInterval(function(){
            //Fire Auto save
            self.$root.getAlerts();
      }, 60000);
  },
}
</script>
